export default {
  API_ENDPOINT: `https://polar-cove-45052.herokuapp.com/api/bookmarks`,
  API_ENDPOINT_LOCAL:`http://localhost:8000/api/bookmarks`,
  API_KEY: process.env.REACT_APP_API_KEY,
}
